import { render, staticRenderFns } from "./MinhasComprasDiretasTabela.vue?vue&type=template&id=9b801fe0&scoped=true"
import script from "./MinhasComprasDiretasTabela.vue?vue&type=script&lang=js"
export * from "./MinhasComprasDiretasTabela.vue?vue&type=script&lang=js"
import style0 from "./MinhasComprasDiretasTabela.vue?vue&type=style&index=0&id=9b801fe0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b801fe0",
  null
  
)

export default component.exports